document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.xo-lightbox');
  if (!trigger) return;

  // Prevent opening again if overlay is already open
  if (document.querySelector('.xo-lightbox-overlay')) return;

  e.preventDefault();

  const src = trigger.getAttribute('href');

  const overlay = document.createElement('div');
  overlay.className = 'xo-lightbox-overlay';
  overlay.innerHTML = `
    <button class="xo-lightbox-close" aria-label="Close">&times;</button>
    <img class="xo-lightbox-image" src="${src}">
  `;

  document.body.appendChild(overlay);

  // Close button
  overlay.querySelector('.xo-lightbox-close').onclick = () => {
    overlay.remove();
  };
});